import { useEffect, useState } from 'react';
import PageWrapper from '../../../../components/Display/PageWrapper';
import { useAccountContext } from '../../../../contexts/AccountContext';
import { privateFetch } from '../../../../utils/apiHelper';
import DocumentPanel from '../../common/document/DocumentPanel';
import MultipleImagePanel from '../../common/image/MultipleImagePanel';
import NewsPanel from './NewsPanel';
import SectionDetail from './SectionDetail';
import SectionPanel from './SectionPanel';

function SectionPage({ isActive, section }) {
  const { accountContext } = useAccountContext();
  const [sectionDetail, setSectionDetail] = useState([]);
  const [panelIsOpen, setPanelIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [documentManagerIsOpen, setDocumentManagerIsOpen] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(undefined);
  const [selectedNews, setSelectedNews] = useState(undefined);
  const [newsManagerIsOpen, setNewsManagerIsOpen] = useState(false);
  const [imagesManagerIsOpen, setImagesManagerIsOpen] = useState(false);

  const fetchSectionDetail = async () => {
    await privateFetch(
      'GET',
      'jeunedargentre',
      `/cu/${accountContext.id}/section/${section.id}/`
    ).then((res) => {
      if (res) setSectionDetail(res);
    });
  };

  useEffect(() => {
    fetchSectionDetail();
  }, [section]);

  const handleUpdateSection = () => {
    setPanelIsOpen(true);
  };

  const updateSection = async (sectionForm) => {
    setLoading(true);
    await privateFetch(
      'PUT',
      'jeunedargentre',
      `/cu/${accountContext.id}/section/${section.id}/`,
      'La section a bien été modifiée',
      JSON.stringify(sectionForm)
    ).then(() => {
      fetchSectionDetail();
      setPanelIsOpen(false);
      setLoading(false);
    });
  };

  const handleCreateNews = () => {
    setSelectedNews(undefined);
    setNewsManagerIsOpen(true);
  };

  const handleUpdateNews = (news) => {
    setSelectedNews(news);
    setNewsManagerIsOpen(true);
  };

  const createSectionNews = async (newsForm) => {
    setLoading(true);
    await privateFetch(
      'POST',
      'jeunedargentre',
      `/cu/${accountContext.id}/section/${section.id}/news/`,
      "L'article a bien été enregistré",
      JSON.stringify(newsForm)
    ).then(() => {
      fetchSectionDetail();
      setLoading(false);
      setNewsManagerIsOpen(false);
    });
  };

  const updateNews = async (newsForm) => {
    setLoading(true);
    await privateFetch(
      'PUT',
      'resources',
      `/cu/${accountContext.id}/news/${selectedNews.id}/`,
      "L'article a bien été modifiée",
      JSON.stringify(newsForm)
    ).then(() => {
      fetchSectionDetail();
      setLoading(false);
      setNewsManagerIsOpen(false);
    });
  };

  const handleDeleteNews = async (news) => {
    await privateFetch(
      'DELETE',
      'resources',
      `/cu/${accountContext.id}/news/${news.id}/`,
      "L'article a bien été supprimée"
    ).then(() => {
      fetchSectionDetail();
      setNewsManagerIsOpen(false);
    });
  };
  const handleCreateDocument = () => {
    setSelectedDocument(undefined);
    setDocumentManagerIsOpen(true);
  };

  const handleUpdateDocument = (document) => {
    setSelectedDocument(document);
    setDocumentManagerIsOpen(true);
  };

  const uploadSectionDocument = async (documentForm) => {
    setLoading(true);
    await privateFetch(
      'POST',
      'jeunedargentre',
      `/cu/${accountContext.id}/section/${section.id}/file/`,
      'Le fichier a bien été enregistrée',
      documentForm,
      false,
      true
    ).then(() => {
      fetchSectionDetail();
      setLoading(false);
      setDocumentManagerIsOpen(false);
    });
  };

  const updateDocument = async (documentForm) => {
    setLoading(true);
    await privateFetch(
      'PUT',
      'resources',
      `/cu/${accountContext.id}/file/${selectedDocument.id}/`,
      'Le document a bien été modifiée',
      documentForm,
      false,
      true
    ).then(() => {
      fetchSectionDetail();
      setLoading(false);
      setDocumentManagerIsOpen(false);
    });
  };

  const handleDeleteDocument = async (document) => {
    await privateFetch(
      'DELETE',
      'resources',
      `/cu/${accountContext.id}/file/${document.id}/`,
      'Le document a bien été supprimée'
    ).then(() => {
      fetchSectionDetail();
      setSelectedDocument(undefined);
    });
  };

  const updateSectionImages = async (images) => {
    await privateFetch(
      'PUT',
      'jeunedargentre',
      `/cu/${accountContext.id}/section/${section.id}/images/`,
      'Les images de la section ont bien été modifiées',
      JSON.stringify({
        images: images.map((image) => image.id)
      })
    ).then(() => {
      fetchSectionDetail();
      setImagesManagerIsOpen(false);
      setLoading(false);
    });
  };

  return (
    <div className={`h-full w-full flex-col ${isActive ? 'flex' : 'hidden'}`}>
      <PageWrapper label={sectionDetail.title}>
        <SectionDetail
          section={sectionDetail}
          handleUpdateSection={handleUpdateSection}
          handleCreateFile={handleCreateDocument}
          handleDeleteFile={handleDeleteDocument}
          handleUpdateFile={handleUpdateDocument}
          handleUpdateNews={handleUpdateNews}
          handleCreateNews={handleCreateNews}
          handleUpdateImages={() => setImagesManagerIsOpen(true)}
        />
      </PageWrapper>
      <SectionPanel
        isOpen={panelIsOpen}
        onClose={setPanelIsOpen}
        section={sectionDetail}
        onUpdate={updateSection}
        loading={loading}
      />
      <DocumentPanel
        document={selectedDocument}
        loading={loading}
        isOpen={documentManagerIsOpen}
        onClose={() => {
          setSelectedDocument(null);
          setDocumentManagerIsOpen(false);
        }}
        onCreate={uploadSectionDocument}
        onUpdate={updateDocument}
      />
      <NewsPanel
        isOpen={newsManagerIsOpen}
        onClose={setNewsManagerIsOpen}
        news={selectedNews}
        loading={loading}
        onCreate={createSectionNews}
        onUpdate={updateNews}
        handleDeleteNews={handleDeleteNews}
        section={sectionDetail.slug}
      />

      <MultipleImagePanel
        loading={loading}
        isOpen={imagesManagerIsOpen}
        onClose={() => {
          setImagesManagerIsOpen(false);
        }}
        images={sectionDetail?.images}
        onValidate={updateSectionImages}
      />
    </div>
  );
}

export default SectionPage;
